'use strict';
const angular = require('angular');

export default angular.module('conduuHQ.jsonView', [])
  .directive('jsonView', function($compile) {
    return {
      restrict: 'E',
      scope: {
        value: '&'
      },
      link: function(scope, element, attrs) {
        scope.guessType = function(obj) {
          var type = Object.prototype.toString.call(obj);

          if (type === "[object Object]") {
            return "Object";
          }

          if (type === "[object Array]") {
            return "Array";
          }

          return "Literal";
        };

        var template =
          `<span ng-switch="guessType(value())">
    <table class="table table-condensed" ng-switch-when="Array" style="margin-bottom: 0">
        <tbody>
            <tr ng-repeat="val in value() track by $index">
                <td style="width:0px; border: none;"><code style="color:darkgrey">{{$index}}</code></td>
                <td ng-switch="guessType(val)" style="border: none">
                    <json-view ng-switch-when="Object" value="::val"></json-view>
                    <json-view ng-switch-when="Array" value="::val"></json-view>
                    <span ng-switch-when="Literal">{{ val }}</span>
                </td>
            </tr>
        </tbody>
    </table>
    <table class="table table-condensed table-bordered" ng-switch-when="Object" style="margin-bottom: 0">
        <tbody>
            <tr ng-repeat="(key, val) in value() track by key">
                <th class="active">{{ key }}</th>
                <td ng-switch="guessType(val)">
                    <json-view ng-switch-when="Object" value="::val"></json-view>
                    <json-view ng-switch-when="Array" value="::val"></json-view>
                    <span ng-switch-when="Literal">{{ val }}</span>
                </td>
            </tr>
        </tbody>
    </table>
</span>`;

        var newElement = angular.element(template);
        $compile(newElement)(scope);
        element.replaceWith(newElement);
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/json-view/json-view.directive.js